import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { TitleMode } from '../ui/title-mode';
import { Subject, fromEvent } from 'rxjs';
import { map, filter, merge, distinctUntilChanged, debounceTime } from 'rxjs/operators';
var UiService = /** @class */ (function () {
    function UiService(router, activatedRoute) {
        var _this = this;
        this.router = router;
        this.activatedRoute = activatedRoute;
        this.whitened$ = new Subject();
        this.title$ = new Subject();
        var endEvents$ = router.events.pipe(filter(function (e) { return e instanceof NavigationEnd; }));
        this.accentuated$ = endEvents$
            .pipe(map(function () { return _this.activatedRoute.snapshot.firstChild.data; }), map(function (data) { return !data.accentuatedMode; }));
        var routeData$ = endEvents$.pipe(map(function () { return _this.activatedRoute.snapshot.firstChild.data; }));
        var noneModeTitle$ = routeData$
            .pipe(filter(function (data) { return !data.titleMode; }), map(function () { return null; }));
        var staticModeTitle$ = routeData$
            .pipe(filter(function (data) { return data.titleMode === TitleMode.Static; }), map(function (data) { return data.title; }));
        noneModeTitle$
            .pipe(merge(staticModeTitle$))
            .subscribe(function (title) { return _this.title$.next(title); });
        var $resize = fromEvent(window, 'resize');
        this.widthResize$ = $resize
            .pipe(map(function () { return window.innerWidth; }), debounceTime(100), distinctUntilChanged());
        this.heightResize$ = $resize
            .pipe(map(function () { return window.innerHeight; }), debounceTime(100), distinctUntilChanged());
    }
    return UiService;
}());
export { UiService };
//# sourceMappingURL=ui.service.js.map